import {http} from "./httpServices";
import api from "../apiConfig";
import jwtDecode from "jwt-decode";

const url = api.global + "/auth";
// const url = api.local + "/auth";
const token = "token";

http.setJwt(getJwt());

export async function login({email, password}) {
  const { data: jwt } = await http.post(url, { email, password });
  localStorage.setItem(token, jwt);
  http.setJwt(jwt);
}

export function loginWithJwt(jwt) {
  localStorage.setItem(token, jwt);
  http.setJwt(jwt);
}

export function logout() {
  localStorage.removeItem(token);
  http.setJwt(null);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(token);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}
export function getJwt() {
  return localStorage.getItem(token);
}

